export const GrowthGradientIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        d="M17.8125 18.5V10.2912C17.8125 9.93655 17.6236 9.61076 17.3268 9.41664C14.9355 7.8525 11.336 4.45057 10.1454 1.54031C10.0664 1.3472 9.72397 1.35191 9.65021 1.54707C8.55163 4.45374 5.14142 7.79827 2.66981 9.41718C2.374 9.61093 2.18652 9.93569 2.18652 10.2893V18.5"
        stroke="url(#paint0_linear_5649_22051)"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M2.18652 12.75C4.51541 11.3752 8.07061 8.9376 9.72529 6.38629C9.80882 6.25749 10.0018 6.25833 10.0846 6.38766C11.6663 8.86087 15.3147 11.4153 17.8125 12.75"
        stroke="url(#paint1_linear_5649_22051)"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M2.18652 15.685C4.98977 14.2887 7.59665 12.9031 9.76259 10.505C9.84061 10.4187 9.97557 10.4147 10.058 10.4969C12.3686 12.8005 15.403 14.56 17.8125 15.685"
        stroke="url(#paint2_linear_5649_22051)"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M2.18652 18.5C4.89291 17.5162 7.17098 16.3826 9.75937 14.2321C9.83353 14.1705 9.94177 14.1698 10.0166 14.2305C12.5281 16.2692 15.1088 17.5169 17.8125 18.5"
        stroke="url(#paint3_linear_5649_22051)"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_5649_22051"
          x1="17.6342"
          y1="1.65257"
          x2="1.7053"
          y2="2.18747"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#65CEFE" />
          <stop offset="1" stopColor="#0C7DFF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_5649_22051"
          x1="17.6342"
          y1="6.42238"
          x2="1.8138"
          y2="7.83685"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#65CEFE" />
          <stop offset="1" stopColor="#0C7DFF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_5649_22051"
          x1="17.6342"
          y1="10.6075"
          x2="1.88288"
          y2="12.3625"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#65CEFE" />
          <stop offset="1" stopColor="#0C7DFF" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_5649_22051"
          x1="17.6342"
          y1="14.341"
          x2="1.97705"
          y2="16.4708"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#65CEFE" />
          <stop offset="1" stopColor="#0C7DFF" />
        </linearGradient>
      </defs>
    </svg>
  )
}
